<div class="row">
    <div class="col-lg-12">
        <div class="box-header page-header with-border ">
            <!-- =================================== TITLE (START)==================================== -->
            <!-- <h3 class="box-title" style="font-family: 'Inconsolata', monospace;font-weight: bold;color: #3c8dbc; margin-left: 10px;"><i class="fa fa-list"></i>

                <span style="text-decoration: underline">

                      <span>Liste des batteries du véhicule :</span>
                      <a style="color: black; text-decoration-color: #3c8dbc;" title="Afficher la véhicule" [routerLink]="['/client/dataManagement/vehicule/form', vehicule.idVehicule, 'SHOW']">{{vehicule.matricule}}</a>

                      <span *ngIf="vehicule.driver"> - conducteur :
                            <a style="color: black; text-decoration-color: #3c8dbc;" title="Afficher le conducteur" [routerLink]="['/client/dataManagement/driver/form', vehicule.driver.idDriver, 'SHOW']">{{vehicule?.driver?.firstName}} {{vehicule?.driver?.lastName}}</a>
                      </span>

                </span>


                <span *ngIf="!vehicule.driver" data-toggle="tooltip" class="badge label-warning">
                      <i class="fa fa-info" aria-hidden="true"></i> Aucun conducteur trouvé !
                </span>

            </h3> -->
            <!-- =================================== TITLE (END)=============))))======================= -->
            <!-- =================================== OPTIONS (START)==================================== -->
            <div class="option-add">

                    <button type="button" class="btn btn-success btn-sm " title="Ajouter"
                    (click)="onAdd()" ><i class="fa fa-plus-circle"></i> </button>

            </div>
            <div *ngIf="batteriesId.length > 0" class="option-delete">
                <span title="Supprimer tout" (click)="onConfirmDeleteMultiple()">
                    <i class="fa fa-minus-circle"></i> Supprimer tout</span>
            </div>
            <!-- =================================== OPTIONS (END)==================================== -->
            <!--==================================== import/Export functionality(START)=============== -->
            <div style="display: inline-block; margin-left: 5px;">
                <div class="option-export">


                            <button type="button" class="btn btn-primary btn-sm" title="Exporter sous format excel"
                            (click)='export()' >Exporter <i class="fa fa-download"></i> </button>


                        <button type="button" class="btn btn-primary btn-sm " title="Importer sous format excel"
                        (click)='importModal.show()' >Importer <i class="fa fa-upload"></i> </button>

                        </div>
            </div>
            <!--==================================== import/Export functionality(END)================= -->
            <!--==================================== Search(START)=============== -->
            <div class="pull-right">
                <div class="inputWithIcon">
                    <input [(ngModel)]="searchTerm" name="searchTerm" type="text" class="form-control input-sm"
                        placeholder="Fournisseur...">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </div>
            </div>
            <!--==================================== Search(END)================= -->
        </div>
    </div>
    <div class="col-lg-12">
        <!-- ========================================== LIST BATTERY (START) ====================================================-->
        <div class="content">
            <div class="table-responsive tableFixHead">
                <table class="table table-striped table-hover table-condensed">
                    <thead>
                        <tr>
                            <th style="width: 2%; text-align: left;"><input type="checkbox" [disabled]="batteries.length == 0"
                                    [checked]="batteries.length == batteriesId.length" (click)="onCheckedAll()"></th>
                            <th style="width:5%">Date Garantie</th>
                            <th style="width:5%">Réparer le</th>
                            <th style="width:5%">Date Expiration</th>
                            <th style="width:5%">Durée Garantie</th>
                            <th style="width:5%">NB</th>
                            <th style="width:5%">Amperage</th>
                            <th style="width:5%">Voltage</th>
                            <th style="width:5%">Numéro Série</th>
                            <th style="width:5%">Marque</th>
                            <th style="width:5%">Fournisseur</th>
                            <th style="width:5%">Coût</th>
                            <th style="width:5%" title="Coût de main d'oeuvre">Coût M.O</th>
                            <th style="width:5%">Référence </th>
                            <th style="width:28%">Observation</th>
                            <th style="width:5%"></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngIf="loading">
                            <td colspan="16" style="text-align: center">
                                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                            </td>
                        </tr>
                        <tr *ngIf="!loading && batteries.length == 0">
                            <td colspan="16">
                                <div class="alert alert-dismissible" style="border-radius: 0px;text-align: center;background-color: #3c8dbc;">
                                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">
                                        ×
                                    </button>
                                    <h4 style="color: white">
                                        <i class="fa fa-exclamation-triangle"></i> Information
                                    </h4>
                                    Veuillez ajouter des informations pour batteries.
                                </div>
                            </td>
                        </tr>
                        <tr *ngFor="let battery of getBatteries()">
                            <td>
                                <input type="checkbox" [checked]="isCheckedInList(battery.id)" (click)="onChecked(battery.id)">
                            </td>
                            <td style="font-weight: bold">
                                {{battery?.operationTime | date: 'dd-MM-yyyy, HH:mm'}}
                            </td>
                            <td style="width:5%;font-weight: bold">
                                {{battery?.actualRepairTime | date: 'dd-MM-yyyy, HH:mm'}}
                            </td>
                            <td style="width:5%;font-weight: bold">
                                {{battery?.expirationDate | date: 'dd-MM-yyyy, HH:mm'}}
                            </td>
                            <td>
                                {{battery?.duration}}
                            </td>
                            <td>
                                {{battery?.number}}
                            </td>
                            <td>
                                {{battery?.amperage}}
                            </td>
                            <td>
                                {{battery?.voltage}}
                            </td>
                            <td>
                                {{battery?.serieNumber}}
                            </td>
                            <td>
                                {{battery?.mark}}
                            </td>
                            <td>{{battery?.provider?.name}}</td>
                            <td> {{battery?.cost | number: '.0-4'}}</td>
                            <td> {{battery?.laborCost | number: '.0-4'}}</td>
                            <td> {{battery?.referenceDADR}}</td>
                            <td>{{battery?.observation}}</td>
                            <td>
                                <button title="Supprimer" style="color: red;" type="button" class="btn btn-sm btn-default"
                                    (click)="onConfirmDelete(battery)">
                                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                                </button>
                                <button title="Modifier" style="color: rgb(2, 157, 196); " type="button" class="btn btn-sm btn-default"
                                    (click)="onUpdate(battery)">
                                    <i class="fa fa-edit" aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <!-- ========================================== LIST BATTERY (END) ====================================================-->
</div>
<!-- ========================================== ADD/UPDATE Modal (START) ====================================================-->
<div class="modal fade" bsModal #batteryModal="bs-modal" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <!-- ========================== Modal TITLE (START) ===============================-->
            <div class="modal-header">
                <button type="button" class="close" (click)="batteryModal.hide()">&times;</button>
                <h4 *ngIf="mode=='ADD'" class="modal-title" style="font-family: 'Inconsolata', monospace;font-weight: bold;color: #3c8dbc;">
                    <i class="fa fa-plus"></i>
                    Ajouter informations batterie</h4>
                <h4 *ngIf="mode=='UPDATE'" class="modal-title" style="font-family: 'Inconsolata', monospace;font-weight: bold;color: #3c8dbc;">
                    <i class="fa fa-edit"></i>
                    Modifier informations batterie</h4>
            </div>
            <!-- ========================== Modal TITLE (END) ===============================-->
            <div class="modal-body">
                <div class="box-body">
                    <app-battery-form [battery]="battery" [vehicule]="vehicule" [group]="group" [mode]="mode" (batteryWasAdded)="batteryWasAdded($event)"
                        (batteryWasUpdated)="batteryWasUpdated($event)">
                    </app-battery-form>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- ========================================== ADD/UPDATE Modal (END) ====================================================-->
<!-- ============================== DELETE MODAL (START) ========================== -->
<div class="modal fade" bsModal #batteryDeleteModal="bs-modal" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="batteryDeleteModal.hide()">&times;</button>
                <h4 class="modal-title">
                    <i class="fa fa-cogs" aria-hidden="true"></i> Êtes-vous sûr ?
                </h4>
            </div>
            <div class="modal-body">
                <div class="alert alert-danger alert-dismissible" style="border-radius: 0px;text-align: center">
                    <h4 style="color: white">
                        <i class="fa fa-exclamation-triangle"></i> Attention !</h4>
                    <span *ngIf="!isDeleteMultiple">Êtes-vous sûr de supprimer cette batterie ?</span>
                    <span *ngIf="isDeleteMultiple">Êtes-vous sûr de supprimer cettes {{batteriesId.length}}
                        batteries
                        ?</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="batteryDeleteModal.hide()">
                    Annuler
                </button>
                <button type="button" class="btn btn-success" (click)="onDelete()">
                    <i class="fa fa-check" aria-hidden="true" *ngIf="!loading"></i>
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Oui, Je confirme
                </button>
            </div>
        </div>
    </div>
</div>
<!-- =============================== DELETE MODAL (END) ============================= -->
<!--=================================Import battery(start) ====================================-->
<div class="modal" role="dialog" bsModal #importModal="bs-modal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="importModal.hide()">&times;
                </button>
                <h4 class="modal-title">
                    <i class="fa fa-cogs" aria-hidden="true"></i> Importer la liste des batteries
                </h4>
            </div>
            <div class="modal-body vertical-spacer">
                <app-import-export-forms [item]='selectedItem' [vehiculeMatricule]='vehicule.matricule' [groupId]="group.idGroupe" (importedItem)='itemWasImported($event)'></app-import-export-forms>
            </div>
            <p></p>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="importModal.hide()">
                    Fermer
                </button>
            </div>
        </div>
    </div>
</div>
<!--=================================Import battery (end) ====================================-->
